import VeganImage from "../assets/foodAttributes/Vegan.png";
import DairyFree from "../assets/foodAttributes/Dairy Free.png";
import Halal from "../assets/foodAttributes/Halal.png";
import Takeaway from "../assets/foodAttributes/Take Away.png";
import Chinese from "../assets/foodAttributes/Chinese.png";
import Smoothies from "../assets/foodAttributes/Smoothies.png";
import Juice from "../assets/foodAttributes/Juices.png";
import Spicy from '../assets/foodAttributes/Spicy.png'
import Low_Calorie from '../assets/foodAttributes/Low Calerie.png'
import Grilled from '../assets/foodAttributes/Grilled.png'
import Peanut_Free from '../assets/foodAttributes/Peanut Free.png'
import Soya_Free from '../assets/foodAttributes/Soy Free.png'
import Meat_Free from '../assets/foodAttributes/Meat Free.png';
import Garlic_Free from '../assets/foodAttributes/Garlic Free.png'
import Peanut_Contain from '../assets/foodAttributes/Peanut Contain.png';
import Soya_Contain from '../assets/foodAttributes/Soy Contain.png';
import Meat_Contain from '../assets/foodAttributes/Meat Contain.png';
import Garlic_Contain from '../assets/foodAttributes/Garlic Contain.png';
import Milk_Contain from "../assets/foodAttributes/Dairy Contain.png"
// import {ApprovalRequest, Product,Request} from "../redux/AllocationRequest";
import { Request } from "../redux/AllocationRequest";

export const getImageUrl = (displayName: string): string => {
  switch (displayName) {
    case "Vegan":
      return VeganImage;
    case "Gluten Free":
      return "https://th.bing.com/th/id/OIP.HVPYs7aXN4wXEKIu3AqSFQHaIr?w=171&h=200&c=7&o=5&dpr=1.3&pid=1.7";

    case "Sugar Free":
      return "https://th.bing.com/th/id/OIP.JNmHqMxmfcUrA569xx7oPAHaHa?w=177&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7";

    case "Dairy-Free":
      return DairyFree;

    case "Halal":
      return Halal;

    case "Takeaway":
      return Takeaway;

    case "Chinese":
      return Chinese;

    case "Smoothies":
      return Smoothies;

    case "Juices":
      return Juice;

    case "Spicy":
      return Spicy;

    case "Low-Calorie":
      return Low_Calorie;

    case "Grilled":
      return Grilled;

    case "Juice":
      return Juice;

    case "Peanut-Free":
      return Peanut_Free;

    case "Soya-Free":
      return Soya_Free;

    case "Meat-Free":
      return Meat_Free;

    case "Garlic-Free":
      return Garlic_Free;

    case "Contains peanut":
      return Peanut_Contain;

    case "Contains Soya":
      return Soya_Contain;

    case "Contains meat":
      return Meat_Contain;

    case "Contains Garlic":
      return Garlic_Contain;

    case "Contains milk":
      return Milk_Contain;

    default:
      return "https://th.bing.com/th/id/OIP.6ktsOLcDR81pbfsloxnSngHaHa?w=165&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7";
  }
};

export const initialRequests: Request[] = [
  { id: "REQ-006", type: "Product Quantity", department: "Sales & Marketing", requester: "Samantha Perera", summary: "1 product(s), 1 units", targetDate: "2026-03-12", status: "Pending" },
  { id: "REQ-001", type: "Product Quantity", department: "Sales & Marketing", requester: "Samantha Perera", summary: "2 product(s), 80 units", targetDate: "2026-03-24", status: "Pending" },
  { id: "REQ-002", type: "Cart Allocation", department: "Distribution", requester: "Kumar Silva", summary: "1 cart(s), 35 units", targetDate: "2026-03-23", status: "Pending" },
  { id: "REQ-003", type: "Special Event", department: "Sales & Marketing", requester: "Nimal Fernando", summary: "ABC Corp Annual Lunch - 100 attendees", targetDate: "2026-03-28", status: "Approved" },
  { id: "REQ-004", type: "Product Quantity", department: "Distribution", requester: "Anjali Dias", summary: "1 product(s), 20 units", targetDate: "2026-03-22", status: "Rejected" },
  { id: "REQ-005", type: "Cart Allocation", department: "Distribution", requester: "Ravi Jayawardena", summary: "1 cart(s), 25 units", targetDate: "2026-03-25", status: "Pending" },
];
